import { useState } from 'react';
import styled from 'styled-components';

import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../translations';

import { ReceptionServiceCreateModalOpener } from './create/ReceptionServiceCreateModalOpener';
import { ReceptionServiceTable } from './table/ReceptionServiceTable';
import { ReceptionServiceTableSearch } from './table/ReceptionServiceTableSearch';

const StyledReceptionServicePanel = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;
   overflow: auto;
   height: 100%;
`;

StyledReceptionServicePanel.displayName = 'StyledReceptionServicePanel';

const ReceptionServiceCreatePrimaryButton = (): JSX.Element => {
   return (
      <ReceptionServiceCreateModalOpener>
         {({ openModal }) => (
            <ActionBar.PrimaryButton
               testId={'receptionServiceCreate'}
               label={receptionServiceTranslationKeys.panel.actionBar.create}
               variant={ButtonVariant.PRIMARY}
               onClick={openModal}
            />
         )}
      </ReceptionServiceCreateModalOpener>
   );
};

type ReceptionServicePanelProps = {
   readonly hasMorePractitioners: boolean;
};

export const ReceptionServicePanel = (props: ReceptionServicePanelProps): JSX.Element => {
   const [searchText, setSearchText] = useState<string | null>(null);

   return (
      <>
         <StyledReceptionServicePanel>
            <ReceptionServiceTableSearch onChange={setSearchText} />
            <ReceptionServiceTable searchText={searchText} hasMorePractitioners={props.hasMorePractitioners} />
         </StyledReceptionServicePanel>
         <ReceptionServiceCreatePrimaryButton />
      </>
   );
};
